import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shiftTypes: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const shiftTypesSlice = createSlice({
  name: 'shiftTypes',
  initialState,
  reducers: {
    fetchShiftTypesStart(state) {
      state.status = 'loading';
    },
    fetchShiftTypesSuccess(state, action) {
      state.status = 'succeeded';
      state.shiftTypes = action.payload;
    },
    fetchShiftTypesFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    createShiftType(state, action) {
      state.shiftTypes.push(action.payload);
    },
    updateShiftType(state, action) {
      const { id, updatedShiftType } = action.payload;
      const existingShiftType = state.shiftTypes.find(
        (shiftType) => shiftType.id === id
      );
      if (existingShiftType) {
        Object.assign(existingShiftType, updatedShiftType);
      }
    },
    deleteShiftType(state, action) {
      const id = action.payload;
      state.shiftTypes = state.shiftTypes.filter(
        (shiftType) => shiftType.id !== id
      );
    },
  },
});

export const {
  fetchShiftTypesStart,
  fetchShiftTypesSuccess,
  fetchShiftTypesFailure,
  createShiftType,
  updateShiftType,
  deleteShiftType,
} = shiftTypesSlice.actions;

export default shiftTypesSlice.reducer;

export const selectAllShiftTypes = (state) => state.shiftTypes.shiftTypes;